// transfers
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ethers } from 'ethers';

import WebbDividerSmall from "../webx/webb-divider-sm";
import WebbDividerMedium from "../webx/webb-divider-md";
import WebbLoader from "../webx/webb-loader";
import WebbModuleInfo from "../webx/webb-module-info";

import { GetUserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { Row, Col, Form, Input, Slider, Button, Result  } from 'antd';


export default function AccountCreditModule() {

  const usxx = GetUserForm();
  const asset = {usid: '6846dd6921014269bbb309a1e6778f088'} // GetUserForm() === "in" ? GetLocalUser() : GetLocalBusiness();

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const history = useHistory();
  
  const [submit, setSubmit] = useState(false);
  const [done, setDone] = useState(false);
  const [check, setCheck] = useState(true);

  const [mask, setMetamask] = useState();
  
  const [account, setAccount] = useState();
  const [chain, setChain] = useState();
  const [network, setNetwork] = useState();
  const [signature, setSignature] = useState();


  const [mint, setMint] = useState(1);
  const [amnt, setAmount] = useState(.1);
  const onChange = (newValue) => {
    setMint(newValue);
    setAmount(newValue/100);
  };

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        setMetamask(window.ethereum && window.ethereum.isMetaMask);
      }
      fetchData()
    } else {}
  },[]);
  
  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      }); 
      window.ethereum.on("accountsChanged", () => {
        window.location.reload();
      });
      // ResetMetamask();
    }
  });

  useEffect( async () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);

        setLoading(false);
      }
      fetchData()
    } else {}
  },[]);

  const formatter = (value) => `${value}`

  const setAccounts = async() => {
    const ethereum = window.ethereum;
    ethereum.request({ method: 'eth_accounts' })
      .then((accounts) => {console.log(accounts[0]); setAccount(accounts[0])})
      .catch((error) => console.error(error));

    const provider = new ethers.providers.Web3Provider(window.ethereum)
    
    const signer = await provider.getSigner(account)
    console.log(signer)

    signer.sendTransaction({
      to: "0xbC1c628bfDc9156e11b2525fc19D64A9AFE8895c",
      value: ethers.utils.parseEther("0.01")
    })
    .then((trxn) => {
      console.log(trxn)
      trxn.wait(1).then((receipt) => console.log (receipt))
    })
    
    // console.log(trxn)
    // const receipt = await trxn.wait();
    // console.log(receipt)
  }

  if (loading) return <WebbLoader/>

  return (
    <>
    {/* info */}
    <div className={submit ? 'd-none' : ''}>
      <WebbModuleInfo data={{text:'Get $MINT Tokens'}} />
      <WebbDividerSmall />
    </div>

    {/* data */}
    <div>

      <p className="text-lead text-bold text-color-main m-0">{'$MINX: '}{mint}</p>
      <p className="text-lead text-color-tone">{'$MATIC: '}{amnt}</p>
      <WebbDividerMedium />
      <Slider
          min={100}
          max={900}
          step={10}
          onChange={onChange}
          value={typeof mint === 'number' ? mint : 0}
          tipFormatter={formatter} 
      />
      <p className="text-small text-color-tone">Move the slider to adjust amount</p>
      

      <WebbDividerMedium />
      <div className={`p-1 px-2 back-color-next text-color-wite rounded-wd hirich cursor`}
        onClick={() => setAccounts()}
        >
        <Row justify="space-between">
          <Col span={21}>
            <Row justify="start" align="middle">
              <Col>
                <i className="lead bx bx-globe m-0 text-icon-sm"></i>
              </Col >
              <Col flex="auto" className="mx-1">Pay via Matic</Col>
            </Row>
          </Col>

          <Col span={3} className="text-end">
            <i className="bx bx-chevron-right m-0 text-icon-sm" ></i>
          </Col>
        </Row>
      </div>
  
      <WebbDividerMedium />
      <div className={`p-1 px-2 back-color-lite text-color-tint rounded-wd cursor`}
        onClick={() => alert('Coming Soon')}
        >
        <Row justify="space-between">
          <Col span={21}>
            <Row justify="start" align="middle">
              <Col>
                <i className="lead bx bx-credit-card m-0 text-icon-sm"></i>
              </Col >
              <Col flex="auto" className="mx-1">Local Payment Method</Col>
            </Row>
          </Col>

          <Col span={3} className="text-end">
            <i className="bx bx-chevron-right text-icon-sm" ></i>
          </Col>
        </Row>
      </div>


    </div>

    {/* action */}
    <div className={submit ? 'back-color-wite text-center mb-3' : 'd-none'}>
      <WebbDividerSmall />
      
      <Result
        status="success"
        title="Congratulations!"
        subTitle="Your Media is Created."
        className={done ? '' : 'd-none'}
        extra={[
          <Button type="primary" key="home" 
            className="back-color-next border-none rounded-wd"
            onClick={()=>history.push(`/${usxx}/home`)}>
            Home
          </Button>,
          <Button key="reload" 
            className="rounded-wd"
            onClick={()=> setSubmit(false)}>
          New Transfer</Button>,
        ]}
      />
      
      <Result
        status="warning"
        title="Error!"
        subTitle="Please try again."
        className={done ? 'd-none' : ''}
        extra={[
          <Button type="primary" key="home" 
            className="back-color-next border-none rounded-wd"
            onClick={()=>history.push(`/${usxx}/home`)}>
            Home
          </Button>,
          <Button key="reload" 
            className="rounded-wd"
            onClick={()=> setSubmit(false)}>
          Try Again</Button>,
        ]}
      />

    </div>


    </>
  );

}